import _objectWithoutProperties from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _classCallCheck from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _assertThisInitialized from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _possibleConstructorReturn from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _asyncToGenerator from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
var _excluded = ["isAllowedToView"];
var __jsx = React.createElement;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import _regeneratorRuntime from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
/** @format */

import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import Unauthenticated from "../components/Unauthenticated";
import { openLoginModal } from "../reducers/user";
import { ACCESS_LEVEL } from "../constants/app";
import { withRouter } from 'next/router';
import { getLslAccessTokenFromCookie } from "../utils/loginHelper";
var getComponentDisplayName = function getComponentDisplayName(Component) {
  return Component.displayName || Component.name || 'Unknown';
};

// validate OAUTH2 LSL token
var validateLslToken = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var data, response;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            data = JSON.stringify({
              lslToken: getLslAccessTokenFromCookie()
            });
            _context.next = 3;
            return fetch('/validate-token', {
              method: 'POST',
              headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
              },
              body: data
            });
          case 3:
            response = _context.sent;
            return _context.abrupt("return", response.json());
          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function validateLslToken() {
    return _ref.apply(this, arguments);
  };
}();
var withProtection = function withProtection(ComposedComponent, options) {
  var accessLevel = options.accessLevel,
    canAccess = options.canAccess;
  var WithProtection = /*#__PURE__*/function (_React$Component) {
    function WithProtection() {
      var _this;
      _classCallCheck(this, WithProtection);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return _possibleConstructorReturn(_this, (_this = _callSuper(this, WithProtection, [].concat(args)), _this.displayName = "WithProtection(".concat(getComponentDisplayName(ComposedComponent), ")"), _this.promptLogin = function () {
        var isAllowedToView = _this.props.isAllowedToView;
        if (isAllowedToView) {
          return;
        }
        _this.props.openLoginModal(window.location.href);
      }, _assertThisInitialized(_this)));
    }
    _inherits(WithProtection, _React$Component);
    return _createClass(WithProtection, [{
      key: "componentDidMount",
      value: function () {
        var _componentDidMount = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
          var _window, _window$sessionStorag;
          var shouldRedirectToOAuthLogin, _yield$validateLslTok, isTokenValid, loginCancelled, _window2, _window2$sessionStora;
          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  shouldRedirectToOAuthLogin = true;
                  if (!getLslAccessTokenFromCookie()) {
                    _context2.next = 7;
                    break;
                  }
                  _context2.next = 4;
                  return validateLslToken();
                case 4:
                  _yield$validateLslTok = _context2.sent;
                  isTokenValid = _yield$validateLslTok.isTokenValid;
                  shouldRedirectToOAuthLogin = !isTokenValid;
                case 7:
                  loginCancelled = (_window = window) === null || _window === void 0 ? void 0 : (_window$sessionStorag = _window.sessionStorage) === null || _window$sessionStorag === void 0 ? void 0 : _window$sessionStorag.getItem('login_cancelled');
                  if (loginCancelled) {
                    (_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$sessionStora = _window2.sessionStorage) === null || _window2$sessionStora === void 0 ? void 0 : _window2$sessionStora.removeItem('login_cancelled');
                  }
                  if (shouldRedirectToOAuthLogin && !loginCancelled) {
                    this.promptLogin();
                  }
                case 10:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, this);
        }));
        function componentDidMount() {
          return _componentDidMount.apply(this, arguments);
        }
        return componentDidMount;
      }()
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(previousProps) {
        var hasAllowedAccessChanged = this.props.isAllowedToView !== previousProps.isAllowedToView;
        if (hasAllowedAccessChanged) {
          this.promptLogin();
        }
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props = this.props,
          isAllowedToView = _this$props.isAllowedToView,
          passThroughProps = _objectWithoutProperties(_this$props, _excluded);
        if (isAllowedToView) {
          return __jsx(ComposedComponent, passThroughProps);
        }
        return __jsx(Unauthenticated, null);
      }
    }]);
  }(React.Component);
  var mapStateToProps = function mapStateToProps(_ref2, _ref3) {
    var user = _ref2.user;
    var query = _ref3.router.query;
    var hasCustomCheck = !_.isUndefined(canAccess) && _.isFunction(canAccess);
    var isAllowedToView = user[accessLevel] || user[ACCESS_LEVEL.HIGH];
    return {
      isAllowedToView: hasCustomCheck ? canAccess(user, query) : isAllowedToView
    };
  };
  var mapDispatchToProps = {
    openLoginModal: openLoginModal
  };
  return withRouter(connect(mapStateToProps, mapDispatchToProps)(WithProtection));
};
var WithHighProtection = function WithHighProtection(Component) {
  return withProtection(Component, {
    accessLevel: ACCESS_LEVEL.HIGH
  });
};
var WithLowProtection = function WithLowProtection(Component) {
  return withProtection(Component, {
    accessLevel: ACCESS_LEVEL.LOW
  });
};
var WithProtection = function WithProtection(config, Component) {
  return withProtection(Component, config);
};
export { WithHighProtection, WithLowProtection, WithProtection };